const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const config = {
  API,
  BACKEND_URL,

  // App Store Links - update these when real URLs are available
  APP_STORE_URL: "#",
  PLAY_STORE_URL: "#",
  APP_STORE_CONFIGURED: false,
  PLAY_STORE_CONFIGURED: false,

  // WhatsApp
  WHATSAPP_NUMBER: "919873554343",
  WHATSAPP_MESSAGE: "Hi I\u2019d like to start a booking with BookMyJab.\n\nName:\nLocation:\nFor (Self / Child / Elderly):\nVaccine (if known):\nPreferred date:",
  WHATSAPP_CONFIGURED: true,

  // Contact
  SUPPORT_PHONE: "+91 98735 54343",
  SUPPORT_EMAIL: "support@bookmyjab.com",

  // Brand
  BRAND_NAME: "BookMyJab",
  TAGLINE: "Premium At-Home Vaccination for Your Family",
  CITY: "Gurgaon",

  // Logo
  LOGO_URL: "/logo-cropped.png",

  getWhatsAppLink: () => {
    const msg = encodeURIComponent(config.WHATSAPP_MESSAGE);
    return `https://wa.me/${config.WHATSAPP_NUMBER}?text=${msg}`;
  },

  getDownloadLink: (platform) => {
    if (platform === 'ios') return config.APP_STORE_CONFIGURED ? config.APP_STORE_URL : null;
    if (platform === 'android') return config.PLAY_STORE_CONFIGURED ? config.PLAY_STORE_URL : null;
    return null;
  }
};

export default config;
